"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hasKey = void 0;

var _curry = require("../curry/curry");

var _is = require("../is/is");

var _hasKey = function _hasKey(key, source) {
  return (0, _is.is)(source) && Object.prototype.hasOwnProperty.call(source, key);
};

var hasKey = (0, _curry.curry)(_hasKey);
exports.hasKey = hasKey;